<div *ngIf="loader" class="spinner">
  <nx-spinner nxSize="large"></nx-spinner>
</div>
<div *ngIf="!loader">
  <div class="truncate">
    <div nxRow class="nx-margin-bottom-s">
      <div nxCol="12">
        <table class="nx-table" *ngIf="documents.length > 0" nxTable nxSort zebra (sortChange)="sortTable($event)">
          <thead>
          <tr nxTableRow>
            <th nxHeaderCell *ngIf="showVersionsFlag">
                <nx-checkbox       
                  [checked]="isAllMarkedForBulkDownload()"           
                  (change)="selectAllItems()"
                  (click)="$event.stopPropagation()"
                  style="transform: scale(0.6); transform-origin: center; display: inline-block;">
                </nx-checkbox>            
            </th>
            <th nxHeaderCell></th>
            <th nxHeaderCell></th>
            <th nxHeaderCell *ngIf="!showVersionsFlag">Version</th>
            <th nxHeaderCell nxSortHeaderCell="coverProcessId" >Vorgang ID</th>
            <th nxHeaderCell nxSortHeaderCell="policyHolderId" >Pers.Nr.DN</th>
            <th nxHeaderCell nxSortHeaderCell="foreignCustomerId">Pers.Nr.AK</th>
            <th nxHeaderCell nxSortHeaderCell="contractNumber">Vertrag APG</th>
            <th nxHeaderCell nxSortHeaderCell="country">Land</th>
            <th nxHeaderCell nxSortHeaderCell="documentDate">Dok.dat.</th>
            <th nxHeaderCell nxSortHeaderCell="documentCategory">Dok.kat.</th>
            <th nxHeaderCell nxSortHeaderCell="documentType">Dok.Typ</th>
            <th nxHeaderCell nxSortHeaderCell="documentTitle">Dok.Titel</th>
            <th nxHeaderCell nxSortHeaderCell="documentProcessed">Dok.bearb.</th>
            <th nxHeaderCell nxSortHeaderCell="documentNotes">Dok.Notiz</th>
            <th nxHeaderCell nxSortHeaderCell="documentStatus">Dok.Status</th>
            <th nxHeaderCell nxSortHeaderCell="inOutFlag">Eingang Ausgang</th>
            <th nxHeaderCell nxSortHeaderCell="documentChannel">Dok.Kanal</th>
            <th nxHeaderCell nxSortHeaderCell="documentPagesNo">Dok.Anzahl Seiten</th>
            <th nxHeaderCell nxSortHeaderCell="confidentialityLevel">Vertraulichkeitsstufe</th>
            <th nxHeaderCell nxSortHeaderCell="dataProtection">Datenschutz</th>
            <th nxHeaderCell nxSortHeaderCell="invoiceNumber">Rechnung Nummer</th>
            <th nxHeaderCell nxSortHeaderCell="barcode">Barcode</th>
            <th nxHeaderCell nxSortHeaderCell="barcodeGroup">Barcode Gruppe</th>
            <th nxHeaderCell nxSortHeaderCell="paperArchiveReference">Papierarchiv Referenze</th>
            <th nxHeaderCell nxSortHeaderCell="paperArchiveReference2">Papierarchiv Referenze 2</th>
            <th nxHeaderCell nxSortHeaderCell="emailReceipt">E-Mail Empfänger</th>
            <th nxHeaderCell nxSortHeaderCell="emailCopyTo">E-Mail Kopie an</th>
            <th nxHeaderCell nxSortHeaderCell="emailSubject">E-Mail Thema</th>
            <th nxHeaderCell nxSortHeaderCell="emailSendTimestamp">E-Mail Zeitstempel</th>
            <th nxHeaderCell nxSortHeaderCell="changeUser">Änderungs User</th>
            <th nxHeaderCell nxSortHeaderCell="modifiedAtDateTime">Änderungs Zeitstempel</th>
            <th nxHeaderCell nxSortHeaderCell="deliverySystem">Liefer System</th>
            <th nxHeaderCell nxSortHeaderCell="loadDate">Lade Datum</th>
            <th nxHeaderCell nxSortHeaderCell="loadTime">Lade Zeit</th>
            <th nxHeaderCell nxSortHeaderCell="loadUser">Lade User</th>
            <th nxHeaderCell nxSortHeaderCell="documentError">Fehler Text</th>
            <th nxHeaderCell nxSortHeaderCell="jobId">Job ID</th>
            <th nxHeaderCell nxSortHeaderCell="retentionDate">Lösch Datum</th>
            <th nxHeaderCell nxSortHeaderCell="dui">DUI</th>
            <th nxHeaderCell nxSortHeaderCell="edmId">EDMID</th>
            <th nxHeaderCell nxSortHeaderCell="originalId">Original Dokument ID</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let document of documents; trackBy: trackByDui">
            <tr nxTableRow selectable (click)="toggleMarked(showVersionsFlag?(document.dui || '') + (document.version || ''):document?.dui)" 
                                (contextmenu)="toggleMarked(showVersionsFlag?(document.dui || '') + (document.version || ''):document?.dui)" 
                        [ngClass]="getRowClass(document)">
              <td nxTableCell *ngIf="showVersionsFlag">
                  <nx-checkbox
                    [checked]="isMarkedForBulkDownload(document?.dui) || false"
                    (change)="toggleBulkDownload(document?.dui)"
                    (click)="$event.stopPropagation()"
                    style="transform: scale(0.6); transform-origin: center; display: inline-block;">
                  </nx-checkbox>
              </td>
              <td nxTableCell>
                <div (click)="openDocument(document); $event.stopPropagation()" style="width: 17px;display: inline-block; margin-right: 1px;">
                  <nx-badge type="active" nxTooltip="Dokument öffnen">
                    <nx-link>
                      <a>
                        <figure nxFigure><img style="width: 17px;" [ngClass]="{'disabled': (showVersionsFlag === false && document.version !== 'current'), 
                          'highlight-green': isOpenItemDisplayed(showVersionsFlag?(document.dui || '') + (document.version || ''):document?.dui)}" 
                          src="assets/icons/open_item.gif" role="none"></figure>
                      </a>
                    </nx-link>
                  </nx-badge>
                </div>
                <div (click)="openDetails(document); $event.stopPropagation()" (contextmenu)="showTechnicalDetails(document, $event); $event.stopPropagation()" style="width: 17px;display: inline-block; margin-right: 1px;">
                  <nx-badge type="active" nxTooltip="Anzeige/Änderung Indexwerte">
                    <nx-link>
                      <a>
                        <figure nxFigure><img src="assets/icons/update_attribute.gif" role="none" style="width: 17px;" [ngClass]="{'highlight-green': isUpdateAttributeDisplayed(document.dui)}" ></figure>
                      </a>
                    </nx-link>
                  </nx-badge>
                </div>
                <div (click)="openShowVersions(document); $event.stopPropagation()" style="width: 17px;display: inline-block; margin-right: 1px;">
                  <nx-badge type="active" nxTooltip="Anzeige Historie Indexwerte: {{document.totalVersions}}">
                    <nx-link>
                      <a>
                        <figure nxFigure><img style="width: 17px;" [ngClass]="{'disabled': showVersionsFlag === false  && document.version !== 'current', 
                          'highlight-green': isVersionsDisplayed(document.dui)}" src="assets/icons/view_version.gif" role="none"></figure>
                      </a>
                    </nx-link>
                  </nx-badge>
                </div>
                <div (click)="importDuplicate(document); $event.stopPropagation()" style="width: 17px;display: inline-block; margin-right: 1px;">
                  <nx-badge type="active" nxTooltip="Duplizieren">
                    <nx-link>
                      <a>
                        <figure nxFigure><img style="width: 17px;" [ngClass]="{'disabled': showVersionsFlag === false  && document.version !== 'current', 
                          'highlight-green': isImportDuplicateDisplayed(document.dui)}" src="assets/icons/duplicate.gif" role="none"></figure>
                      </a>
                    </nx-link>
                  </nx-badge>
                </div>
              </td>
              <td nxTableCell>
                <button
                  nxAction
                  type="button"
                  class="my-button"
                  (click)="openDocument(document)"
                  title="Dokument öffnen"
                  [disabled]="showVersionsFlag === false && document.version !== 'current'"
                >
                  <nx-link>
                    <a>
                      <figure nxFigure><img [ngClass]="{'disabled': showVersionsFlag === false && document.version !== 'current'}"  src="assets/icons/{{document.descriptiveIconPath}}" role="none"></figure>
                    </a>
                  </nx-link>
                </button>
              </td>
              <td nxTableCell *ngIf="!showVersionsFlag">
                <div>{{document.version}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.coverProcessId}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.policyHolderId}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.foreignCustomerId}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.contractNumber}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.country">{{countriesData[document!.country]}}</div>
              </td>
              <td nxTableCell>
                <div>{{formatDate(document.documentDate)}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.documentCategory">{{documentCategoryData[document!.documentCategory]}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.documentType">{{documentTypeData[document!.documentType]}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.documentTitle}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.documentProcessed">{{documentProcessedData[document!.documentProcessed]}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.documentNotes}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.documentStatus">{{documentStatusData[document!.documentStatus]}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.inOutFlag">{{inOutFlagData[document!.inOutFlag]}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.documentChannel">{{documentChannelData[document!.documentChannel]}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.documentPagesNo}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.confidentialityLevel">{{confidentialityLevelData[document!.confidentialityLevel]}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.dataProtection">{{dataProtectionData[document!.dataProtection]}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.invoiceNumber}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.barcode}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.barcodeGroup}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.paperArchiveReference}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.paperArchiveReference2}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.emailReceipt}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.emailCopyTo}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.emailSubject}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.emailSendTimestamp}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.changeUser}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.modifiedAtDateTime}}</div>
              </td>
              <td nxTableCell>
                <div *ngIf="document.deliverySystem">{{deliverySystemData[document!.deliverySystem]}}</div>
              </td>
              <td nxTableCell>
                {{ formatDate(document.loadDate) }}
              </td>
              <td nxTableCell>
                <div>{{document.loadTime}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.loadUser}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.documentError}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.jobId}}</div>
              </td>
              <td nxTableCell>
                <div>{{formatDate(document.retentionDate)}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.dui}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.edmId}}</div>
              </td>
              <td nxTableCell>
                <div>{{document.originalId}}</div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="pag">
    <div nxRow>
      <div nxCol="2">
        <button *ngIf="showVersionsFlag" nxButton="primary small" (click)="modifySearch()" type="button" class="my-search-button">Suche ändern</button>
      </div>
      <div nxCol="1">
      </div>
      <div nxCol="5">
        <nx-pagination
          [nxCount]="totalItems"
          [nxPage]="page"
          nxType="advanced"
          [nxPerPage]="pageSize"
          (nxGoPrev)="page = page - 1; onPageChange(page)"
          (nxGoNext)="page = page + 1; onPageChange(page)"
          (nxGoPage)="onPageChange($event)"
          data-cy="table-right_pagination"
        >
        </nx-pagination>
      </div>
      <div nxCol="2">
        <button *ngIf="showVersionsFlag" nxButton="primary small" [disabled]="!showBulkDownloadButton()" (click)="bulkDownload()" 
                  (contextmenu)="bulkDownloadPrallel(); $event.stopPropagation()" type="button" class="my-search-button" nxTooltip="Mehrere Dateien gleichzeitig als ZIP-Paket herunterladen"
  nxTooltipPosition="top" >Sammel-Download</button>
      </div>      
      <div nxCol="2">
        <button nxButton="primary small" (click)="generateSearchLink()"  type="button" class="my-search-button" >E-Mail Suchlink</button>
      </div>
    </div>
  </div>
</div>
